import axios from 'axios';

import {
  FEATURES_NPS_PATH,
  FEATURES_NPS_SUBMISSION_SUFFIX,
} from 'lib/config';
import { errorGenerator } from 'lib/errorGenerator';
import { generatoreCode } from 'lib/generateCode';
import Paths from 'lib/paths';

export type SubmitNpsParams = {
  apiBaseUrl: string;
  appCode: string;
  questionnaireId: string;
  score: number;
  comment: string;
  contactConsent: boolean;
};

export type SubmitNpsResult = { ok: true } | { ok: false };

export function buildNpsSubmissionUrl(
  apiBaseUrl: string,
  appCode: string,
): string {
  return Paths.join(
    Paths.join(Paths.join(apiBaseUrl, FEATURES_NPS_PATH), appCode),
    FEATURES_NPS_SUBMISSION_SUFFIX,
  );
}

export async function submitNpsQuestionnaire(
  params: SubmitNpsParams,
): Promise<SubmitNpsResult> {
  const { apiBaseUrl, appCode, questionnaireId, score, comment, contactConsent } =
    params;
  const url = buildNpsSubmissionUrl(apiBaseUrl, appCode);
  const trimmedComment = comment.trim();
  const body: {
    questionnaireId: string;
    score: number;
    contactConsent: boolean;
    comment?: string;
  } = {
    questionnaireId,
    score,
    contactConsent,
  };
  if (trimmedComment) {
    body.comment = trimmedComment;
  }

  try {
    const response = await axios.post(url, body, {
      withCredentials: true,
      maxRedirects: 5,
      validateStatus: (s) => s === 200 || s === 409,
    });

    if (response.status === 200 || response.status === 409) {
      return { ok: true };
    }

    return { ok: false };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      if (status === 401) {
        window.open('/rqx/session/logout', '_self');
        return { ok: false };
      }
      if (status === 409) {
        return { ok: true };
      }
    }
    const code = generatoreCode(8).toString();
    await errorGenerator(
      code,
      error,
      'apiError npsSubmission',
      `POST /rqx/api/features/nps/${appCode}/submission`,
    );
    return { ok: false };
  }
}
